import nfeCufMetadata from './data/metadata.json';
import type { NfeCufDataVersion } from './types.js';

export const NFE_CUF_DATA_VERSION: NfeCufDataVersion = nfeCufMetadata as NfeCufDataVersion;
